import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import fetchMiddleware from './middleware/fetch';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    rootReducer,
    window.INITIAL_STATE || {},
    composeEnhancers(applyMiddleware(thunk, fetchMiddleware)),
);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js